<template>
  <div>
    <div class="demo-side-icon" v-on:click="isDemoMethod(isDemo)">
      <button type="button" class="modal-btn">
        <span>Sucursales</span>
      </button>
    </div>
    
    <div class="demos-side-content" v-if="isDemo">
      <div class="modal-header">
        <h2>Sucursales</h2>
        <button type="button" class="close" v-on:click="isDemoMethod(isDemo)">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            
<!-- Querétaro -->
<h3>Querétaro</h3>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Querétaro</span>
      <div>
        <h4>Pedro Escobedo</h4>
        <ul>
          <li>Calle Cuahutemoc #28</li>
          <li>Zona Centro</li>
          <li>448-688-0074</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Querétaro</span>
      <div>
        <h4>Pedro Escobedo 2</h4>
        <ul>
          <li>Calle Panamericana #29b</li>
          <li>Col. Centro</li>
          <li>448-488-2150</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Querétaro</span>
      <div>
        <h4>San Joaquín</h4>
        <ul>
          <li>Calle Corregidora #12</li>
          <li>Zona Centro</li>
          <li>441-107-7895</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Querétaro</span>
      <div>
        <h4>Amelaco</h4>
        <ul>
          <li>Andador Juárez #53A</li>
          <li>Col. Centro</li>
          <li>448-488-3815</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Querétaro</span>
      <div>
        <h4>Cadereyta</h4>
        <ul>
          <li>Madero #100</li>
          <li>Zona Centro</li>
          <li>441-690-2209</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Querétaro</span>
      <div>
        <h4>Cadereyta</h4>
        <ul>
          <li>Calle Madero #9</li>
          <li>Col. Centro</li>
          <li>441-690-0653</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<hr>            
<!-- Estado de México -->
<h3>Estado de México</h3>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Estado de México</span>
      <div>
        <h4>Polotitlán</h4>
        <ul>
          <li>Calle Constitución</li>
          <li>Zona Centro</li>
          <li>562-158-6063</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Estado de México</span>
      <div>
        <h4>Aculco</h4>
        <ul>
          <li>Calle Macario Pérez, Plaza Tulipanes #2</li>
          <li>Zona Centro</li>
          <li>562-956-0229</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<hr>
<!-- Hidalgo -->
<h3>Hidalgo</h3>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Hidalgo</span>
      <div>
        <h4>Zimapan</h4>
        <ul>
          <li>Emiliano Zapata #02</li>
          <li>Col. Centro</li>
          <li>441-110-4009</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Hidalgo</span>
      <div>
        <h4>Zimapan</h4>
        <ul>
          <li>Pedro Trujillo s/n</li>
          <li>Col. Centro</li>
          <li>441-690-2209</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Hidalgo</span>
      <div>
        <h4>Huichapan</h4>
        <ul>
          <li>Ignacio Gutiérrez #25</li>
          <li>Col. Centro Histórico</li>
          <li>761-782-2925</li>
        </ul>
      </div>
    </a>
  </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-12">
  <div class="demo-item">
    <a href="/">
      <span>Hidalgo</span>
      <div>
        <h4>Tezontepec</h4>
        <ul>
          <li>Av. Fray Juan de Sanabria</li>
          <li>Barrio Morelos Sur</li>
          <li>761-733-5359</li>
        </ul>
      </div>
    </a>
  </div>
</div>

            
            
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemoSidebar",
  data() {
    return {
      isDemo: false,
    };
  },
  methods: {
    isDemoMethod(isDemo) {
      return (this.isDemo = !isDemo);
    },
  },
};
</script>
